export default __webpack_public_path__ + "static/media/trener7.fce1f1e2.png";